import $ from 'jquery';
import Class from './ClassNames';
import { makeNoResultsHtml, makeResultsDateRangeHeading } from './../../htmlShared';
import { makePerformanceListHtml } from './Performance';
import DateFormatter from '../../date/EventListingDateFormatter';

class EventMonthList {
  constructor() {
    this.$el = $(`<div class="${Class.BASE}__list-container">`);
    this.dayFormatter = DateFormatter.standardDate;
    this.resultsFormatter = DateFormatter.month;
    this.isSingleDayView = false;
  }

  makeListHtml(date) {
    return makeResultsDateRangeHeading(this.resultsFormatter(date));
  }

  setupView(date) {
    this.$el.append(this.makeListHtml(date));
  }

  formatDate(date) {
    return this.resultsFormatter(date);
  }

  /**
   * @param {Map} perfMap
   * @param {Date} date
   * @return {Map}
   */
  filterResults(perfMap, date) {
    // We don't want to show any spillover events from
    // the previous or next months on list view
    const filtered = new Map();

    perfMap.forEach((perfs, key) => {
      const perfDate = perfs[0].iso8601Date;

      if (perfDate.getMonth() === date.getMonth()) {
        filtered.set(key, perfs);
      } else {
        // console.warn(`Skipping ${perfs.length} event(s) on '${perfDate}' in list month view`);
      }
    });

    return filtered;
  }

  clearResults() {
    this.$el.html('');
  }

  /**
   * @param {Map} perfMap
   * @param {Date} date
   */
  renderResults(perfMap, date) {
    this.$el.empty();

    const filteredPerfMap = this.filterResults(perfMap, date);

    if (filteredPerfMap.size > 0) {
      this.setupView(date);

      const days = Array.from(filteredPerfMap, ([dateKey, dayPerfs]) => ({
        perfDate: dayPerfs[0].iso8601Date,
        listHtml: makePerformanceListHtml(dayPerfs, dateKey),
      }));

      if (this.isSingleDayView) {
        days.forEach(({ listHtml }) => this.$el.append(listHtml));
      } else {
        const $parentList = $(`<ul class="${Class.BASE}__list"></ul>`);

        days.forEach(({ perfDate, listHtml }) => {
          $parentList.append(`
            <li>
              <h4 class="${Class.BASE}__list-day-heading">${this.dayFormatter(perfDate)}</h4>
              ${listHtml}
            </li>
          `);

          this.$el.append($parentList);
        });
      }
    } else {
      const noResultsHtml = makeNoResultsHtml(this.resultsFormatter(date));
      this.$el.append(noResultsHtml);
    }
  }
}

export default EventMonthList;
